<div class="mvd_alert--container" [ngClass]="{open : showComponent}">
    <div class="mvd_alert--results">
        <h2 class="mvd_alert--header">{{ validationResultsTitle ? validationResultsTitle : 'Alerts'}} <button class="close" type="button" (click)="close()">&times;</button></h2>
        <button class="btn--accent" (throttle-click)="requestAll()" *ngIf="showRequestAll()" [disabled]="isLoading">Request all</button>
        <ul class="mvd_alert__group">
            <li class="mvd_alert--info" *ngFor="let information of displayInformationalMessages; let i = index">
                <i class="material-icons"></i>
                <strong>Info -</strong>
                <a *ngIf="information.state != undefined && information.state.validationGroupTypes != undefined && information.state.validationGroupTypes.length > 0 && information.relatedUIElement != undefined && information.relatedUIElement.length > 0"
                   href="javascript:void(0)"
                   (click)="sendValidationGroupMessage(information.state.validationGroupTypes)">
                    {{ information.relatedUIElement }}
                </a>
                {{ information.errorMessage }}
            </li>
            <li class="mvd_alert--error" *ngFor="let error of displayErrors">
                <i class="material-icons"></i>
                <strong>Error -</strong>
                <a *ngIf="error.state != undefined && error.state.validationGroupTypes != undefined && error.state.validationGroupTypes.length > 0 && error.relatedUIElement != undefined && error.relatedUIElement.length > 0"
                   href="javascript:void(0)"
                   (click)="sendValidationGroupMessage(error.state.validationGroupTypes)">
                    {{ error.relatedUIElement }}
                </a>
                {{ error.errorMessage }}
            </li>
            <li class="mvd_alert--warning" *ngFor="let override of displayOverrides; let i = index;">
                <i class="material-icons"></i>
                <button *ngIf="!override?.state?.escalationRequested" (throttle-click)="requestOverride(override)" [disabled]="isLoading">Request Override</button>
                <strong>Override -</strong>
                <a *ngIf="override.state != undefined && override.state.validationGroupTypes != undefined && override.state.validationGroupTypes.length > 0 && override.relatedUIElement != undefined && override.relatedUIElement.length > 0"
                   href="javascript:void(0)"
                   (click)="sendValidationGroupMessage(override.state.validationGroupTypes)">
                    {{ override.relatedUIElement }}
                </a>
                {{ override.errorMessage }}
                <b *ngIf="override?.state?.escalationRequested">Override request made successfully</b>
            </li>
            <li class="mvd_alert--warning" *ngFor="let override of cdlApprovalMessages; let i = index;">
                <i class="material-icons"></i>
                <button (throttle-click)="openTransactionTransferConfirmationModal(override)" [disabled]="isLoading">Request Transfer</button>
                <strong>Transfer -</strong>
                <a *ngIf="override.state != undefined && override.state.validationGroupTypes != undefined && override.state.validationGroupTypes.length > 0 && override.relatedUIElement != undefined && override.relatedUIElement.length > 0"
                   href="javascript:void(0)"
                   (click)="sendValidationGroupMessage(override.state.validationGroupTypes)">
                    {{ override.relatedUIElement }}
                </a>
                {{ override.errorMessage }}
                <b *ngIf="override?.state?.escalationRequested">Override request made successfully</b>
            </li>
            <li class="mvd_alert--warning" *ngFor="let override of overridableComplianceSatisfyMessages; let i = index;">
                <i class="material-icons"></i>
                <button *ngIf="(false == override?.state?.escalationRequested) && (override?.state?.ValidationResourceId != activeWithdrawalAndPrivilegeNotId)" (throttle-click)="requestOverride(override)" [disabled]="isLoading">
                    Request Override 
                </button>
                <button *ngIf="false == override?.state?.escalationRequested" (click)="navigateToCompliance(override)">Satisfy</button>
                <strong>Compliance -</strong>
                <a *ngIf="override.state != undefined && override.state.validationGroupTypes != undefined && override.state.validationGroupTypes.length > 0 && override.relatedUIElement != undefined && override.relatedUIElement.length > 0"
                   href="javascript:void(0)"
                   (click)="sendValidationGroupMessage(override.state.validationGroupTypes)">
                    {{ override.relatedUIElement }}
                </a>
                {{ override.errorMessage }}
                <b *ngIf="true == override?.state?.escalationRequested">Override request made successfully</b>
            </li>
            <li class="mvd_alert--warning" *ngFor="let msg of complianceSatisfyMessages; let i = index;">
                <i class="material-icons"></i>
                <button *ngIf="false == msg?.state?.escalationRequested" (click)="navigateToCompliance(msg)">Satisfy</button>
                <strong>Compliance -</strong>
                <a *ngIf="msg.state != undefined && msg.state.validationGroupTypes != undefined && msg.state.validationGroupTypes.length > 0 && msg.relatedUIElement != undefined && msg.relatedUIElement.length > 0"
                   href="javascript:void(0)"
                   (click)="sendValidationGroupMessage(msg.state.validationGroupTypes)">
                    {{ msg.relatedUIElement }}
                </a>
                {{ msg.errorMessage }}
            </li>
            <li class="mvd_alert--warning" *ngFor="let approval of displayApprovals; let i = index;">
                <i class="material-icons"></i>
                <button *ngIf="false == approval?.state?.escalationRequested" (click)="requestApproval(approval)">Request Approval</button>
                <strong>Approval -</strong>
                <a *ngIf="(approval?.state?.validationGroupTypes?.length > 0) && (approval?.relatedUIElement?.length > 0)"
                   href="javascript:void(0)"
                   (click)="sendValidationGroupMessage(approval.state.validationGroupTypes)">
                    {{ approval.relatedUIElement }}
                </a>
                {{ approval.errorMessage }}
                <b *ngIf="true == approval?.state?.escalationRequested">Approval request made successfully</b>
            </li>
            <li class="mvd_alert--warning" *ngFor="let confirmationWarning of displayConfirmationWarnings">
                <i class="material-icons"></i>
                <button *ngIf="!confirmationWarning.confirmed" (click)="approveConfirmationWarning(confirmationWarning)">Yes</button>
                <button *ngIf="!confirmationWarning.confirmed" (click)="cancelConfirmationWarning(confirmationWarning)">No</button>
                <strong>Confirmation Warning-</strong>
                <a *ngIf="confirmationWarning.state != undefined && confirmationWarning.state.validationGroupTypes != undefined && confirmationWarning.state.validationGroupTypes.length > 0 && confirmationWarning.relatedUIElement != undefined && confirmationWarning.relatedUIElement.length > 0"
                   href="javascript:void(0)"
                   (click)="sendValidationGroupMessage(confirmationWarning.state.validationGroupTypes)">
                    {{ confirmationWarning.relatedUIElement }}
                </a>
                {{ confirmationWarning.errorMessage }}
                <b *ngIf="confirmationWarning.confirmed">Confirmation made successfully</b>
            </li>
            <li class="mvd_alert--warning" *ngFor="let warning of displayWarnings; let i = index;">
                <i class="material-icons"></i>
                <button *ngIf="!showWarningMessage" (click)="clearWarning(i)">Clear Warning</button>
                <button *ngIf="warning?.state?.ValidationResourceId == pendingWithdrawalId" (click)="navigateToCompliance(i)">
                    Satisfy
                </button>
                <strong>Warning -</strong>
                <a *ngIf="warning.state != undefined && warning.state.validationGroupTypes != undefined && warning.state.validationGroupTypes.length > 0 && warning.relatedUIElement != undefined && warning.relatedUIElement.length > 0"
                   href="javascript:void(0)"
                   (click)="sendValidationGroupMessage(warning.state.validationGroupTypes)">
                    {{ warning.relatedUIElement }}
                </a>
                {{ warning.errorMessage }}
                <b *ngIf="showWarningMessage">Only Accountant can clear this Warning</b>
            </li>
            <li class="mvd_alert--error" *ngFor="let nmvtisException of nmvtisExceptionMessages">
                <i class="material-icons"></i>
                <strong>NMVTIS: </strong> {{ nmvtisException.errorMessage }}
                <button (click)="showNmvtisModal(nmvtisException)">Click To Open</button>
            </li>

            <li class="mvd_alert--error" *ngFor="let warning of nmvtisValidationWarnings">
                <i class="material-icons"></i>
                <strong>NMVTIS: </strong> {{ warning.errorMessage }}
                <button (click)="showNmvtisMessagesAgain()">Show Message</button>
            </li>
        </ul>
    </div>
</div>